import { NumberInputComponentV2 } from './number-input-v2.component';
import { UserService } from './../../../base-services/user.service';
import { ChangeDetectorRef, ChangeDetectionStrategy, Input } from '@angular/core';
import { Component } from '@angular/core';
import { MakeProvider } from '../../abstract-custom-control';
import { DecimalPipe } from '@angular/common';
@Component({
    selector: 'yt-number-input-v3',
    templateUrl: './number-input-v3.component.html',
    providers: [ MakeProvider(NumberInputComponentV3) ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberInputComponentV3 extends NumberInputComponentV2 {
    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected userService: UserService,
        protected decimalPipe: DecimalPipe
    ){
        super(changeDetectorRef, userService, decimalPipe);
    }
 @Input() selectOnEntry: boolean = false;

 ngAfterViewInit(){
     //this.value = 0;
        //this.onBlur();
        
    let __this = this;
    setTimeout(() => {
        if(this.selectOnEntry) {
            this.inputControl.nativeElement.setSelectionRange(0, this.inputControl.nativeElement.value.length);
        }
    }, 100);
}

    Clear(){
        this.value = 0;
        this.onBlur();
    }

    
}